(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('StepStatus', StepStatus);

    StepStatus.$inject = ['$resource'];

    function StepStatus ($resource) {
        var resourceUrl =  'api/step-status/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
